import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.to-string";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.object.freeze";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, addObj, putObj, delObj, deptRoleList } from '@/api/admin/role';
import { getAllMenu, getRoleMenu, setRoleMenu, getRole } from '@/api/admin/role';
import Selecttree from '@/components/treeSelect';
import { mapGetters } from 'vuex';
export default {
  name: 'roleManage',
  components: {
    // roleForm: () => import('./roleForm'),
    // authForm: () => import('./authForm')
    Selecttree: Selecttree
  },
  data: function data() {
    return {
      param: {
        page: {
          current: 1,
          size: 10
        },
        roleId: '',
        menuIds: []
      },
      loading: false,
      tableData: [],
      columnlist: Object.freeze([// { prop: 'roleId', label: '序号' },
      {
        prop: 'title',
        label: this.$t('userManage.roleName')
      }, {
        prop: 'roleDesc',
        label: this.$t('roleManage.roleDescription')
      }, {
        prop: 'createTime',
        label: this.$t('roleManage.createTime')
      }]),
      page: {
        current: 1,
        size: 10,
        total: 0,
        pages: 1
      },
      form: {
        dialogFormVisible: false,
        title: '',
        formItem: {
          parentId: '',
          roleName: '',
          roleDesc: '',
          roleCode: ''
        },
        rules: Object.freeze({
          roleName: [{
            required: true,
            message: this.$t('userManage.addRoleName'),
            trigger: 'blur'
          }],
          roleDesc: [{
            required: true,
            message: this.$t('userManage.addRoleDes'),
            trigger: 'blur'
          }],
          parentId: [{
            required: true,
            message: this.$t('userManage.addUpRole'),
            trigger: 'blur'
          }]
        })
      },
      auth: {
        dialogAuthVisible: false,
        menuData: [],
        parentIds: [],
        activeMenuData: [],
        defaultProps: {
          children: 'children',
          label: 'title'
        }
      },
      sys_role_add: true,
      sys_role_edit: true,
      sys_role_del: true,
      sys_role_perm: true,
      prop: {
        value: 'id',
        label: 'title'
      },
      isClearable: true,
      // 可清空（可选）
      isAccordion: true,
      istrue: true
    };
  },
  computed: _objectSpread({}, mapGetters(['permission'])),
  created: function created() {
    this.init();
  },
  mounted: function mounted() {
    var that = this; //   setTimeout(function(){
    //     that.permissions['sys_role_add'] && (that.sys_role_add = that.permissions['sys_role_add']);
    //     that.permissions['sys_role_edit'] && (that.sys_role_edit = that.permissions['sys_role_edit']);
    //     that.permissions['sys_role_del'] && (that.sys_role_del = that.permissions['sys_role_del']);
    //     that.permissions['sys_role_perm'] && (that.sys_role_perm = that.permissions['sys_role_perm']);
    //   },1000)
  },
  methods: {
    getValue: function getValue(e) {
      this.form.formItem.parentId = e;
    },
    init: function init() {
      this.getRoleData();
    },
    // 获取角色数据
    getRoleData: function getRoleData() {
      var _this = this;

      // this.loading = true;
      deptRoleList(this.param.page).then(function (res) {
        res = res.data.data; // res.records.map((item,index)=>{
        //     if(item.createTime){
        //         item.createTime = item.createTime.split(' ')[0]
        //     }
        // })

        _this.tableData = res; // this.loading = false;
        // const { total, pages, current, size } = res;
        // this.page = { total, pages, current, size };
      });
    },
    // 分页导航
    handleCurrentChange: function handleCurrentChange(val) {
      this.param.page.current = val;
      this.getRoleData();
    },
    // 新增角色的表单
    handleAdd: function handleAdd() {
      this.form.title = this.$t('userManage.addUpRole');
      this.form.formItem.roleCode = this.getRandomCode(8);
      this.form.dialogFormVisible = true; // FIXME: 后台的创建时间不对
    },
    // 修改角色的表单
    handleEdit: function handleEdit(index, row) {
      if (row.id == '1') {
        this.istrue = false;
      } else {
        this.istrue = true;
      }

      this.form.title = this.$t('userManage.reviseRole');
      this.form.dialogFormVisible = true;
      var id = row.id,
          roleName = row.roleName,
          roleDesc = row.roleDesc,
          roleCode = row.roleCode,
          parentId = row.parentId;
      this.form.formItem = {
        id: id,
        roleName: roleName,
        roleDesc: roleDesc,
        roleCode: roleCode,
        parentId: parentId
      };
    },
    // 提交表单
    handleSubmit: function handleSubmit() {
      var _this2 = this;

      if (this.form.title === this.$t('userManage.addUpRole')) {
        this.$refs.ruleForm.validate(function (valid) {
          if (valid) {
            addObj(_this2.form.formItem).then(function (res) {
              if (res.data.code === 200) {
                _this2.$message.success(_this2.$t('alarmSetting.addSuc'));

                _this2.getRoleData();
              } else {
                _this2.$message.error(_this2.$t('alarmSetting.addFauRepeat'));
              }

              _this2.closeDia();
            });
          } else {
            _this2.$message.warning(_this2.$t('alarmSetting.fillComplete'));

            return;
          }
        });
      } else {
        this.$refs.ruleForm.validate(function (valid) {
          if (valid) {
            putObj(_this2.form.formItem).then(function (res) {
              if (res.data.code === 200) {
                _this2.$message.success(_this2.$t('alarmSetting.chaSuc'));

                _this2.getRoleData();
              } else {
                _this2.$message.error(_this2.$t('alarmSetting.chaFauRepeat'));
              }

              _this2.closeDia();
            });
          } else {
            _this2.$message.warning(_this2.$t('alarmSetting.fillComplete'));

            return;
          }
        });
      }
    },
    handleCancel: function handleCancel(done) {
      this.form.formItem = {};
      this.istrue = true;
      done();
    },
    closeDia: function closeDia() {
      this.form.formItem = {};
      this.istrue = true;
      this.form.dialogFormVisible = false;
    },
    // 删除角色
    handleDel: function handleDel(index, row) {
      var _this3 = this;

      // 二次确认删除
      this.$confirm(this.$t('alarmSetting.promptContent') + "?", this.$t('alarmSetting.prompt'), {
        type: 'warning'
      }).then(function () {
        delObj({
          ids: row.id
        }).then(function (res) {
          if (res.data.code === 200) {
            _this3.$message.success(_this3.$t('alarmSetting.deleteSuc'));

            _this3.getRoleData();
          } else {
            _this3.$message.error(_this3.$t('alarmSetting.deleteFau'));
          }
        });
      }).catch(function () {});
    },

    /**
     * 权限功能
     */
    // 获取角色权限菜单
    getMenuData: function getMenuData() {
      var _this4 = this;

      // 获取全部菜单
      getAllMenu().then(function (res) {
        if (res.data.code === 200) {
          _this4.auth.menuData = res.data.data.menu; // 获取选中菜单权限

          getRole(_this4.param.roleId).then(function (res) {
            _this4.auth.activeMenuData = res.data.data.menu;
            _this4.auth.dialogAuthVisible = true;
          });
        } else {
          _this4.$message.error(res.data.msg);
        }
      });
    },
    // 权限修改表单
    handleAuth: function handleAuth(index, row) {
      this.auth.activeMenuData.length = 0;
      this.param.roleId = row.id;
      this.getMenuData();

      if (this.auth.activeMenuData.length === 0) {// 在分配电站时就设置默认电站
      }
    },
    handleAuthSubmit: function handleAuthSubmit() {
      var _this5 = this;

      var totalNode = this.$refs.tree.getCheckedKeys().toString();
      console.log(this.param, '--params', this.$refs.tree.getCheckedKeys(), this.$refs.tree.getHalfCheckedKeys());
      setRoleMenu(this.param.roleId, totalNode).then(function (res) {
        if (res.data.code === 200) {
          _this5.$message.success(_this5.$t('roleManage.updateSuc'));
        } else {
          _this5.$message.error(_this5.$t('roleManage.upDateFauRepeat'));
        }

        _this5.closeAuth();
      });
    },
    handleAuthCancel: function handleAuthCancel(done) {
      this.auth.activeMenuData = [];
      done();
    },
    closeAuth: function closeAuth() {
      this.auth.activeMenuData = [];
      this.auth.dialogAuthVisible = false;
    },
    // 功能函数
    getRandomCode: function getRandomCode(length) {
      if (length > 0) {
        var data = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
        var nums = '';

        for (var i = 0; i < length; i++) {
          var r = parseInt(Math.random() * 61);
          nums += data[r];
        }

        return nums;
      } else {
        return false;
      }
    },
    isInArray: function isInArray(arr, value) {
      if (arr.indexOf && typeof arr.indexOf == 'function') {
        var index = arr.indexOf(value);

        if (index >= 0) {
          return true;
        }
      }

      return false;
    }
  }
};